import { useRef, useCallback, useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

const UpdateInfoBox = ({ data }) => {
  // CSVLink 라이브러리 접근용
  const tableRef = useRef(null);
  // filename 처리용
  const location = useLocation();
  console.log('location: ', location.pathname.split('/')[2]);

  // state for CSV 라이브러리
  const [excelData, setExcelData] = useState(null);
  const [excelHeader, setExcelHeader] = useState(null);

  // useEffect for set CSV 파일 && CSV 헤더
  useEffect(() => {
    if (data) {
      const { freeRankingData, paidRankingData, grossRankingData, date } = data;
      if (freeRankingData && paidRankingData && grossRankingData) {
        let result = [];
        freeRankingData.forEach((item, index) => {
          let temp = {};
          temp['freeRankData'] = item;
          temp['rank'] = (index + 1).toString();
          result.push(temp);
        });
        paidRankingData.forEach((item, index) => {
          result[index]['paidRankData'] = item;
        });
        grossRankingData.forEach((item, index) => {
          result[index]['grossRankData'] = item;
        });
        console.log('result: ', result);
        setExcelData(result);
        setExcelHeader([
          { label: 'Rank', key: 'rank' },
          { label: 'Free', key: 'freeRankData.title' },
          { label: 'Paid', key: 'paidRankData.title' },
          { label: 'Gross', key: 'grossRankData.title' },
        ]);
      }
    }
  }, [data]);

  const onClickHandler = useCallback(() => {
    tableRef.current.link.click();
  }, [tableRef]);

  return (
    <>
      <div className="data-help">
        <p className="data-update">Updated : {data && moment(data?.date).format('YYYY.MM.DD')}</p>
        <button type="button" className="btn-ico excel" onClick={onClickHandler}>
          Download Excel
        </button>
      </div>
      {excelData && excelHeader && (
        <div>
          <CSVLink
            data={excelData}
            headers={excelHeader}
            target="_blank"
            filename={location.pathname.split('/')[2].toUpperCase()}
            className="hidden"
            ref={tableRef}
          ></CSVLink>
        </div>
      )}
    </>
  );
};

export default UpdateInfoBox;
